import { memo } from 'react';
import { Handle, Position, NodeProps, useReactFlow } from 'reactflow';
import { Calendar, Trash2, Info } from 'lucide-react';

export const PostReservationNode = memo(({ id }: NodeProps) => {
  const { deleteElements } = useReactFlow();

  const handleDelete = () => {
    deleteElements({ nodes: [{ id }] });
  };

  return (
    <div className="bg-neutral-900 border-2 border-purple-500/40 rounded-lg p-4 min-w-[320px] shadow-lg">
      <Handle type="target" position={Position.Top} className="w-3 h-3 !bg-purple-500" />

      <div className="flex items-center gap-2 mb-3">
        <Calendar className="w-5 h-5 text-purple-400" />
        <span className="font-bold text-white">Pós-Reserva</span>
        <div className="ml-auto flex items-center gap-1">
          <button
            onClick={handleDelete}
            className="text-red-400 hover:text-red-300 transition-colors p-1"
            title="Deletar nó"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>

      <div className="space-y-3">
        <div className="flex items-start gap-2 p-3 bg-blue-500/10 border border-blue-500/30 rounded-lg">
          <Info className="w-4 h-4 text-blue-400 flex-shrink-0 mt-0.5" />
          <div className="text-xs text-brand-ivory/90 leading-relaxed">
            Este nó é acionado automaticamente após uma reserva confirmada.
            Use as variáveis abaixo nas mensagens seguintes.
          </div>
        </div>

        <div className="space-y-2">
          <p className="text-xs font-semibold text-brand-gold">Variáveis disponíveis:</p>
          <div className="grid grid-cols-1 gap-1.5">
            <div className="text-xs text-brand-ivory/70 bg-neutral-800 px-2 py-1.5 rounded font-mono">
              {'{{nome_cliente}}'} - Nome do cliente
            </div>
            <div className="text-xs text-brand-ivory/70 bg-neutral-800 px-2 py-1.5 rounded font-mono">
              {'{{numero_reserva}}'} - Número da reserva
            </div>
            <div className="text-xs text-brand-ivory/70 bg-neutral-800 px-2 py-1.5 rounded font-mono">
              {'{{data_inicio}}'} - Data de início
            </div>
            <div className="text-xs text-brand-ivory/70 bg-neutral-800 px-2 py-1.5 rounded font-mono">
              {'{{data_fim}}'} - Data de término
            </div>
            <div className="text-xs text-brand-ivory/70 bg-neutral-800 px-2 py-1.5 rounded font-mono">
              {'{{hora_inicio}}'} - Hora de início
            </div>
            <div className="text-xs text-brand-ivory/70 bg-neutral-800 px-2 py-1.5 rounded font-mono">
              {'{{hora_fim}}'} - Hora de término
            </div>
            <div className="text-xs text-brand-ivory/70 bg-neutral-800 px-2 py-1.5 rounded font-mono">
              {'{{valor_reserva}}'} - Valor total
            </div>
            <div className="text-xs text-brand-ivory/70 bg-neutral-800 px-2 py-1.5 rounded font-mono">
              {'{{numero_parcelas}}'} - Nº de parcelas
            </div>
            <div className="text-xs text-brand-ivory/70 bg-neutral-800 px-2 py-1.5 rounded font-mono">
              {'{{valor_parcela}}'} - Valor da parcela
            </div>
            <div className="text-xs text-brand-ivory/70 bg-neutral-800 px-2 py-1.5 rounded font-mono">
              {'{{quantidade_pessoas}}'} - Qtd. de pessoas
            </div>
            <div className="text-xs text-brand-ivory/70 bg-neutral-800 px-2 py-1.5 rounded font-mono">
              {'{{nome_ambiente}}'} - Nome do ambiente
            </div>
            <div className="text-xs text-brand-ivory/70 bg-neutral-800 px-2 py-1.5 rounded font-mono">
              {'{{imagem_ambiente_1}}'} - URL da imagem 1
            </div>
            <div className="text-xs text-brand-ivory/70 bg-neutral-800 px-2 py-1.5 rounded font-mono">
              {'{{imagem_ambiente_2...10}}'} - URLs até 10
            </div>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Bottom} className="w-3 h-3 !bg-purple-500" />
    </div>
  );
});

PostReservationNode.displayName = 'PostReservationNode';
